 export const themes = {
    'gradient-blue': { primary: '#667eea', secondary: '#764ba2', accent: '#f093fb', text: '#1a202c' },
    'sunset': { primary: '#ff6b6b', secondary: '#ffd93d', accent: '#6bcf7f', text: '#2d3748' },
    'ocean': { primary: '#4facfe', secondary: '#00f2fe', accent: '#43e97b', text: '#1a202c' },
    'midnight': { primary: '#2d3561', secondary: '#c05c7e', accent: '#f3826f', text: '#ffffff' },
    'forest': { primary: '#56ab2f', secondary: '#a8e063', accent: '#7ed56f', text: '#2d3748' }
  };